const MAX_SHORT_NAME_LENGTH = 20;

export const shortComponentName = (name: string): string => {
  const nameFits = name.length <= MAX_SHORT_NAME_LENGTH;
  if (nameFits) {
    return name;
  }
  const lastWordBreak = name.slice(0, MAX_SHORT_NAME_LENGTH + 1).lastIndexOf(' ');
  const nameHasWordBreak = lastWordBreak > 0;
  const shortName = nameHasWordBreak
    ? name.slice(0, lastWordBreak)
    : name.slice(0, MAX_SHORT_NAME_LENGTH);
  return `${shortName.trimEnd()}…`;
};
